import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

interface BookingSectionProps {
  setSelectedItem: React.Dispatch<React.SetStateAction<number>>;
  selectedItem: number;
}

export const BookingSection: React.FC<BookingSectionProps> = ({
  setSelectedItem,
  selectedItem
}) => {
	const [newReservation, setNewReservation] = useState<boolean>(false);
	const [isDisabled, setIsDisabled] = useState<boolean>(false);
	const [availableTimes, setAvailableTimes] = useState<string[]>([]);
	const [disabledDates, setDisabledDates] = useState<string[]>([]);
	const [formData, setFormData] = useState({
		name: "",
		email: "",
		date: "",
		time: "",
		phone: "",
		service: "",
		message: "",
		hairdresser: selectedItem
	});

	const isDateDisabled = (date: Date) => {
		const formattedDate = date.toLocaleDateString("en-CA");

		const today = new Date();
		const maxDate = new Date(today.setDate(today.getDate() + 7));
		maxDate.setHours(0, 0, 0, 0);
		date.setHours(0, 0, 0, 0);

		if (date > maxDate) {
			return true;
		}

		// Disable weekends (Saturday and Sunday)
		const dayOfWeek = date.getDay();
		if (dayOfWeek === 0) {
		  return true;
		}
		
		if (disabledDates) {
			return disabledDates.includes(formattedDate);
		}

		return false;
	};

	const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
		const { name, value } = e.target;
		setFormData((prevData) => ({ ...prevData, [name]: value.toString() }));
	};

	useEffect(() => {
		if (formData.date) {
		// Fetch available times for the selected date
		fetch(`https://api.berberaj032.rs/api/booking/available-times?date=${formData.date}&hairdresser=${selectedItem}`)
			.then((res) => res.json())
			.then((data) => setAvailableTimes(data));
		}
	}, [formData.date]);

	const getServiceName = (service: string) => {
		switch (service) {
			case "1" : return "šišanje";
			case "2" : return "stilizovanje brade";
			case "3" : return "šišanje i stilizovanje brade";
			default : return "N/A";
		}
	}

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		setIsDisabled(true);
		try {
		  const phonePattern = /^(\+3816|06)(([0-6]|[8-9])\d{6,7}|(77|78)\d{5,6})$/;
		  
		  if (!phonePattern.test(formData.phone)) {
			alert(`Uneli ste neispravan broj telefona. ${formData.phone}`);
			return;
		  }
		  
		  const response = await fetch("https://api.berberaj032.rs/api/bookingsnewev2", {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(formData),
		  });
		  
		  const data = await response.json();
		  alert (data.message);

		  setFormData({
			name: "",
			email: "",
			date: "",
			time: "",
			phone: "+381",
			service: "",
			message: "",
			hairdresser: selectedItem
		  });
		  setNewReservation(!newReservation)
		} catch (error) {
			console.error("Greška prilikom slanja zahteva:", JSON.stringify(error));
			alert("Došlo je do greške prilikom zakazivanja. Molimo Vas pokušajte da osvežite stranicu ili pokušajte kasnije.");
		} finally {
			setIsDisabled(false)
		}
	};

	  useEffect(() => {
		// Fetch disabled dates (dates without free slots)
		fetch(`https://api.berberaj032.rs/api/booking/disabled-dates?hairdresser=${selectedItem}`)
		.then((res) => res.json())
		.then((data) => setDisabledDates(data));
	  }, [newReservation]);

	  const generateTimeOptions = (): string[] => {
		let startHour: number;
		let endHour: number;
		
		if (!formData.date) return []

		const dayOfWeek = new Date(formData.date).getDay()
		// Postavljanje radnih sati prema danu u nedelji
		if (selectedItem.toString() === '2' ) {
			startHour = 12;
			endHour = 17;
		} else if (dayOfWeek >= 1 && dayOfWeek <= 4) { // Ponedeljak - Četvrtak
			startHour = 10;
			endHour = 19;
		} else if (dayOfWeek === 5) { // Petak
			startHour = 8;
			endHour = 19;
		} else if (dayOfWeek === 6) { // Subota
			startHour = 8;
			endHour = 17;
		} else { // Nedelja (ako je potrebno)
			return [];
		}
	
		const times: string[] = [];
		for (let hour = startHour; hour < endHour; hour++) {
			times.push(`${hour.toString().padStart(2, "0")}:00`);
			if (hour < endHour) {
				times.push(`${hour.toString().padStart(2, "0")}:30`);
			}
		}

		return times.filter(time => !availableTimes.includes(time));
	};	

  return (
    <section className="ftco-section ftco-booking bg-light">
    	<div className="container">
    		<div className="row justify-content-center pb-3">
          <div className="col-md-10 heading-section text-center">
          	<span className="subheading">Zakazivanje</span>
            <h2 className="mb-4">zakažite svoj termin</h2>
            <p style={{ fontSize: '20px' }}>
				Rezervišite svoj termin brzo i lako! Popunite formu i osigurajte svoju posetu već danas – ne čekajte, ugrabite priliku da zablistate!
			</p>
          </div>
        </div>
        <h3 className="vr">Pozovite nas: 060 422 3434</h3>        
    		<div className="row justify-content-center">
    			<div className="col-md-10">
					<form onSubmit={handleSubmit} className="appointment-form">
						<div className="row">
							<div className="col-sm-6">
								<div className="form-group">
									<input
									type="text"
									className="form-control"
									name="name"
									value={formData.name}
									onChange={handleChange}
									placeholder="Ime i prezime*"
									required
									/>
								</div>
							</div>
							<div className="col-sm-6">
								<div className="form-group">
									<input
									type="email"
									className="form-control"
									name="email"
									value={formData.email}
									onChange={handleChange}
									placeholder="Email*"
									required
									/>
								</div>
							</div>
							<div className="col-sm-6">
								<div className="form-group">
								<DatePicker
									value={formData.date}
									onChange={(date: Date | null) =>
										setFormData((prevData) => ({
											...prevData,
											date: date
											? `${date.getFullYear()}-${(date.getMonth() + 1)
												.toString()
												.padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}`
											: ""
										}))
									}
									filterDate={(date: Date) => !isDateDisabled(date)}
									minDate={new Date()}
									className="form-control"
									dateFormat="yyyy-MM-dd"
									placeholderText="Izaberite datum*"
									required
								/>
								</div>
							</div>
							<div className="col-sm-6">
								<div className="form-group">
									<select
										name="time"
										className="form-control"
										value={formData.time}
										onChange={handleChange}
										required
									>
										<option hidden value="">
											Izaberite vreme*
										</option>
										{generateTimeOptions().map((time) => (
											<option key={time} value={time}>
												{time}
											</option>
										))}
									</select>
								</div>
							</div>
							<div className="col-sm-6">
								<div className="form-group">
									<PhoneInput
										inputStyle={{ width: '100%' }}
										country={"rs"}
										onlyCountries={['rs']}
										value={formData.phone}
										onChange={phone => setFormData((prevData) => ({ ...prevData, phone: `+${phone}` }))}
									/>
								</div>
							</div>
							<div id="service-wrapper" className="col-sm-6">
								<div className="form-group">
									<select
									name="service"
									className="form-control"
									value={formData.service}
									onChange={handleChange}
									required
									>
									<option hidden value="">Izaberite uslugu*</option>
									<option value="1">Šišanje</option>
									<option value="2">Stilizovanje brade</option>
									<option value="3">Šišanje i stilizovanje brade</option>
									</select>
								</div>
							</div>
							<div className="col-sm-12">
								<div className="form-group">
									<textarea
									name="message"
									className="form-control"
									value={formData.message}
									onChange={handleChange}
									placeholder="Poruka za nas"
									/>
								</div>
							</div>						
						</div>
						<div className="form-group btns-wrapper" style={{ display: "flex", justifyContent: "center" }}>
							<input
								type="button"
								style={{ borderRadius: "20px", marginInline: 10 }}
								onClick={() => setSelectedItem(-1)}
								value="Nazad"
								className="btn btn-primary"
							/>
							<input
								type="submit"
								style={{ borderRadius: "20px", marginInline: 10 }}
								value="Rezervišite termin"
								className="btn btn-primary"
								disabled={isDisabled}
							/>
						</div>
					</form>
    			</div>
    		</div>
    	</div>
    </section>
  );
};
